import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import PromoCodeButton from "../../buttons/PromoCodeButton";
import {
    addManualPromotionID,
    getCampaignsByName,
    removeErplyPromoCode,
    removeManualPromotionID,
    setErplyPromoCode
} from "../../redux/actions";
import Translate from "../../localization/Translate";
import {getAttributeValue} from "../../util/helperFunctions";
export default function ({}) {
    const dispatch = useDispatch();
    const erplyPromoCode = useSelector((state) => state.rootReducer.erplyPromoCode);
    const customer = useSelector((state) => state.rootReducer.customer);

    return <PromoCodeButton
        promotionSet={erplyPromoCode !== false}
        onRemovePromotion={() => {
            dispatch(removeManualPromotionID(erplyPromoCode.campaignID));
            dispatch(removeErplyPromoCode());
        }}
        promotionSetClass={erplyPromoCode.status === 'error' ? "negativeActionButton" :
            erplyPromoCode.status === 'pending' ? "warningActionButton" : "positiveActionButton"}
        promotionSetButtonName={<><Translate id="Code"/> - {erplyPromoCode.code} - <Translate id={erplyPromoCode.message}/></>}
        onPromotionInputDone={(value) => {
            dispatch(setErplyPromoCode(value, "pending", "validating"));
            dispatch(getCampaignsByName(value, (data) => {
                console.log("Coupon: getCampaignsByName", data);
                let campaigns = data.filter(el => el.name.toUpperCase() === value.toUpperCase());
                if(campaigns.length > 0){
                    let campaignIDs = campaigns.reduce((acc, el) => {
                        acc.push(el.campaignID);
                        return acc;
                    }, []).join(',');
                    let campaign = campaigns[0];
                    let customerIdentified = parseInt(getAttributeValue((campaign), "customerIdentified")) === 1;
                    console.log("Coupon: ", {customerIdentified, customer});
                    let percentageOff = campaign.percentageOffMatchingItems;
                    if(percentageOff === 0){
                        percentageOff = campaign.percentageOffEntirePurchase;
                    }
                    if(customerIdentified && (customer === false || customer.default)){
                        return setErplyPromoCode(value, "error", "Applies only for identified customers", campaignIDs, customerIdentified, percentageOff);
                    }else{
                        dispatch(addManualPromotionID(campaignIDs));
                        return setErplyPromoCode(value, "applied", "applied", campaignIDs, customerIdentified, percentageOff);
                    }
                }
                return setErplyPromoCode(value, "error", "Coupon does not exist");
            }, () => {
                return {
                    type: "CAMPAIGN_NOT_FOUND"
                }
            }));
        }}
    />;
}
